
<div class="jumbotron text-center">
  <h3>
    404
  </h3>
  <p>
    No se encuentra el recurso
  </p>
</div>
